import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DotLoader} from "react-spinners";
import {xpressApi, EMAIL_DONOR_PASS, RECORD_STAT} from '../../providers/xpress_api';

let emailAddress = "";

export default class XpressDialog extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            open: props.open,
            type: props.type,
            component: props.component,
            title: props.title,
            firstButton: props.firstButton,
            handleFirstButtonClick: props.handleFirstButtonClick, // Function to execute when firstButton is clicked. handleClose will be used if not specified
            secondButton: props.secondButton,
            handleSecondButtonClick: props.handleSecondButtonClick, // Function to execute when secondButton is clicked. handleClose will be used if not specified
            content: props.content, // For use when the content is non-text (i.e. a <div> element)
            contentText: props.contentText, // For use when the content is strictly text (i.e. elements wrappable within a <p> element)
            handleClose: props.handleClose,
            emailPackage: props.emailPackage,
            altButton: props.altButton,
            clearBarcode: props.clearBarcode,
            generateBarcode: props.generateBarcode,
            emailPlaceholder: props.emailPlaceholder,
            emailSuccessMessage: props.emailSuccessMessage,
            emailInvalidMessage: props.emailInvalidMessage,
            validEmail: true,
            emailSending: false,
            emailSent: false
        };

        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.emailInputRef = React.createRef();
    }

    handleClickOpen()
    {
        this.setState({open: true})
    }

    handleClose = (event, reason) => {
        // Prevent closing the dialog by clicking the background
        if (reason && reason === "backdropClick") {
            return;
        }

        if (this.state.type === 'email') {
            this.setState({ validEmail: true, emailSent: false });
        }

        this.setState({open: false})
    }

    componentWillReceiveProps(props)
    {
        this.setState({
            open: props.open,
            title: props.title,
            content: props.content,
            contentText: props.contentText,
            firstButton: props.firstButton,
            handleFirstButtonClick: props.handleFirstButtonClick,
            secondButton: props.secondButton,
            handleSecondButtonClick: props.handleSecondButtonClick,
            altButton: props.altButton,
        });
    }


    handleChange(event)
    {
        emailAddress = event.target.value;
    }


    async sendEmail() {
        emailAddress = emailAddress.trim();
        let emailPackage = this.state.emailPackage;
        emailPackage.emailAddress = emailAddress;

        if (emailAddress && emailAddress.match(/.+?@{1}.+\..+/g)) {
            this.setState({
                validEmail: true,
                emailSending: true
            });

            await xpressApi.post(EMAIL_DONOR_PASS, emailPackage);

            this.setState({
                emailSending: false,
                emailSent: true
            });

            await xpressApi.get(RECORD_STAT, {
                    params: {
                        bloodCenterId: emailPackage.bloodCenterId,
                        type: 'email',
                        emailAddress: emailAddress
                    }
            });
        }
        else {
            this.setState({
                validEmail: false,
                emailSent: false
            });
        }
    }

    render()
    {
        let content;
        let actions;

        if (this.state.type === 'email')
        {
            if (this.state.emailSent) {
                content =
                <DialogContent>
                    <DialogContentText>
                        {this.state.emailSuccessMessage}
                    </DialogContentText>
                </DialogContent>;

                actions =
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            {this.state.altButton}
                        </Button>
                    </DialogActions>;
            }
            else {
                const enter = e => {
                    if (e.key === 'Enter') {
                        this.sendEmail(e).then();
                    }
                }

                content =
                    <DialogContent>
                        <DialogContentText>
                            {!this.state.emailSending && <input size="50" type="text" className="form-control" placeholder={this.state.emailPlaceholder} aria-label="Email" aria-describedby="basic-addon1" onKeyDown={enter} onChange={this.handleChange} autoFocus/>}
                            {!this.state.validEmail && <span style={{fontWeight: 'bold', color: 'red'}}>{this.state.emailInvalidMessage}</span>}
                            {this.state.emailSending && <DotLoader css={"display: block; margin-left: auto; margin-right: auto;"} sizeUnit={"px"} size={50} color={'red'} loading={true}/>}
                        </DialogContentText>
                    </DialogContent>;

                actions =
                    <DialogActions>
                        {!this.state.emailSending &&
                            <div>
                                <Button onClick={this.sendEmail} color="primary">
                                    {this.state.firstButton}
                                </Button>

                                <Button onClick={this.handleClose} color="primary">
                                    {this.state.secondButton}
                                </Button>
                            </div>
                        }
                    </DialogActions>;
            }
        }
        else if (this.state.type === 'generateBarcode')
        {
            content =
                <DialogContent>
                    <DialogContentText>
                        {this.state.contentText}
                    </DialogContentText>
                </DialogContent>;

            actions =
                <DialogActions>
                    <Button onClick={this.state.generateBarcode} color="primary">
                        {this.state.firstButton}
                    </Button>
                    <Button onClick={this.handleClose} color="primary">
                        {this.state.secondButton}
                    </Button>
                </DialogActions>
        }
        else {
            content =
                <DialogContent>
                    {
                        /* If the contentText prop was used, wrap it in a DialogContentText element. Otherwise, display the content as-is */
                        (this.state.contentText && <DialogContentText>{this.state.contentText}</DialogContentText>)
                        ||
                        (this.state.content)
                    }
                </DialogContent>;

            actions =
                <DialogActions>
                    <Button onClick={this.state.handleFirstButtonClick ? this.state.handleFirstButtonClick : this.handleClose} color="primary">
                        {this.state.firstButton}
                    </Button>
                    {this.state.secondButton && 
                        <Button onClick={this.state.handleSecondButtonClick ? this.state.handleSecondButtonClick : this.handleClose} color="primary">
                            {this.state.secondButton}
                        </Button>
                    }
                </DialogActions>
        }

        return (
            <div>
                <Dialog maxWidth="lg" open={this.state.open} onClose={this.handleClose} aria-labelledby="responsive-dialog-title" disableEscapeKeyDown>
                    <DialogTitle id="responsive-dialog-title">{this.state.title}</DialogTitle>
                    {content}
                    {actions}
                </Dialog>
            </div>
        );
    }
}
